import "../item.js";

window.AppointmentBooking ??= {};
window.AppointmentBooking.Wizard ??= {};
window.AppointmentBooking.Wizard.Views ??= {};
window.AppointmentBooking.Wizard.Views.Header ??= {};
window.AppointmentBooking.Wizard.Views.Header.MainMenu ??= {};

AppointmentBooking.Wizard.Views.Header.MainMenu.HelpItem = class HelpItem extends (
  AppointmentBooking.Wizard.Views.Header.MainMenu.Item
) {
  constructor() {
    super(...arguments);
    this.initialize = this.initialize.bind(this);
  }

  initialize() {
    super.initialize(...arguments);

    // BEHAVIOUR

    return this.listenTo(this.booking, "change:booking_number change:validated_booking_number", this.render);
  }
};
AppointmentBooking.Wizard.Views.Header.MainMenu.HelpItem.prototype.template = "header/main_menu/item/help";
AppointmentBooking.Wizard.Views.Header.MainMenu.HelpItem.prototype.className =
  "appointment-booking-wizard-main-menu-help-item";
